import { api } from './client.js';
import type { Store } from '../lib/store.js';

export interface Course {
  courseId: string;
  title: string;
  done: boolean;
  qty: number;
  catalogItemId: string | null;
  store: Store;
  createdAt: string;
}

export interface CreateCourseInput {
  title?: string;
  catalogItemId?: string;
  qty?: number;
  store: Store;
}

/** `?store=` est requis côté API : pas de défaut à deviner ici (ADR 0011 § 5). */
export async function listCourses(store: Store): Promise<Course[]> {
  const r = await api<{ courses: Course[] }>(`/courses?store=${store}`);
  return r.courses;
}

export async function createCourse(input: CreateCourseInput): Promise<Course> {
  const r = await api<{ course: Course }>('/courses', {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return r.course;
}

export async function updateCourse(
  cid: string,
  patch: { title?: string; done?: boolean; qty?: number }
): Promise<Course> {
  const r = await api<{ course: Course }>(`/courses/${cid}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return r.course;
}

export async function deleteCourse(cid: string): Promise<void> {
  await api<void>(`/courses/${cid}`, { method: 'DELETE' });
}

export async function clearCourses(store: Store, onlyDone = false): Promise<void> {
  const qs = onlyDone ? '&done=true' : '';
  await api<void>(`/courses?store=${store}${qs}`, { method: 'DELETE' });
}
